<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
        <form class="o-form -sm" @submit.prevent="updateSiteSubscription(form)">
            <div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>
            <fieldset class="o-form__inner" v-if="!$apollo.loading">
                <h1 class="o-form__title">Abonnement</h1>
                <div class="o-form__item">
                    <Input
                        v-model="form.name" 
                        placeholder="Nom"
                        label="Nom"
                        :required="true"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <!-- <div class="o-form__item">
                    <div class="o-form__item__text">
                        type : {{ form.type }}, Owner
                    </div>
                </div> -->
                <div class="o-form__item">
                    <Select
                        :options="companies.data"
                        placeholder="Choisir une compagnie"
                        label="Compagnie"
                        v-model="form.company"
                        :clearable="false"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item -button">
                    <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary">
                        Sauvegarder
                        <q-icon name="save" class="o-ico -right" />    
                    </button>
                </div>
                <!-- <input
                    type="text"
                    name="name"
                    placeholder="Phone work"
                    v-model="form.type"
                ><br> -->
            </fieldset>
        </form>
    </div>
</template>

<script>
    import { updateSiteSubscription } from '@/graphql/siteSubscription/mutations';
    import { COMPANIES } from '@/graphql/company/queries'
    import { SITESUBSCRIPTION } from '@/graphql/siteSubscription/queries'

    export default {
        name: 'siteSubscription',
        apollo: {
            siteSubscription: {
                query: SITESUBSCRIPTION,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update (siteSubscription){
                    this.form = Object.assign({}, siteSubscription.siteSubscription);
                    return siteSubscription
                },
            },
            companies: {
                query: COMPANIES,
                fetchPolicy: 'cache-first',
            }
        },
        data(){
            return {
                selectedCompany: 'Choisir une compagnie',
                form: {},
            }
        },
        mounted: async function(){
        },
        methods: {
            async updateSiteSubscription(updateSiteSubscriptionDetails){
                updateSiteSubscriptionDetails.company_id=this.form.company.id
                await this.$apollo.mutate({
                    mutation: updateSiteSubscription,
                    variables: { ...updateSiteSubscriptionDetails }
                }).then((data) => {
                    this.form = Object.assign({}, data.data.updateSiteSubscription);
                    this.$q.notify({type: 'positive', message: "Abonnement : "+updateSiteSubscriptionDetails.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
